<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" :persistent='true' width="85%" height="100%" class="modalDialog">
            <div class="memberAdd">
                <v-card class="cardWrap">
                    <CardTitle :title="page_title" />
                    <v-card-actions class="cardWrap__scroll">
                        <v-form
                            class="cardWrap__fromArea"
                            ref="member_form"
                            v-model="valid"
                            :lazy-validation="lazy"
                        >
                            <v-container>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">氏名</div>
                                    <v-text-field
                                        class="px-3"
                                        :disabled="inputDisable"
                                        :rules="[rules.required_family_name, rules.max_length_family_name]"
                                        v-model="from_set_data.family_name"
                                        label="姓"
                                        required
                                    />
                                    <v-text-field
                                        class="px-3"
                                        :disabled="inputDisable"
                                        :rules="[rules.required_given_name, rules.max_length_given_name]"
                                        v-model="from_set_data.given_name"
                                        label="名"
                                        required
                                    />
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">権限</div>
                                    <v-select
                                        class="px-3"
                                        :disabled="inputDisable"
                                        :items="user_divs"
                                        item-text="code_name"
                                        item-value="code"
                                        v-model="from_set_data.user_div"
                                        label="権限"
                                    ></v-select>
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">ゴルフ場</div>
                                    <v-select
                                        class="px-3"
                                        :disabled="inputDisable"
                                        :items="golf_courses"
                                        item-text="golf_name"
                                        item-value="golf_code"
                                        v-model="golf_courses_val"
                                        label="ゴルフ場"
                                    ></v-select>
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">ID</div>
                                    <v-text-field
                                        class="px-3"
                                        :disabled="inputDisable"
                                        v-model="from_set_data.user_name"
                                        :rules="[rules.required_user_id]"
                                        label="ID"
                                    />
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">メールアドレス</div>
                                    <v-text-field
                                        class="px-3"
                                        :disabled="inputDisable"
                                        v-model="from_set_data.email"
                                        :rules="[rules.required_email, rules.format_email, rules.max_length_email]"
                                        label="メールアドレス"
                                        required
                                    />
                                </v-row>
                                <v-row justify="space-around">
                                    <div class="cardWrap__fromArea__title">パスワード</div>
                                    <v-text-field
                                        v-if="modeStatus !== 'addMode'"
                                        type="text"
                                        class="px-3"
                                        v-model="from_set_data.password"
                                        label="パスワード"
                                        :rules="[rules.required_password, rules.format_password, rules.format_password_complexity, rules.max_length_password, rules.min_length_password]"
                                        :disabled="inputDisable"
                                    />
                                    <v-text-field
                                        v-if="modeStatus === 'addMode'"
                                        :type="show_password ? 'text' : 'password'"
                                        class="px-3"
                                        v-model="from_set_data.password"
                                        :rules="[rules.required_password, rules.format_password, rules.format_password_complexity, rules.max_length_password, rules.min_length_password]"
                                        label="パスワード"
                                    />
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-actions>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
                        <v-btn v-if="modeStatus === 'addMode'" color="green darken-4" text @click="validateCheck">追加する</v-btn>
                        <v-btn :disabled="btn[3].isActive" v-if="modeStatus === 'checkMode'" color="green darken-4" text @click="InfoChangeData">管理ユーザーを変更する</v-btn>
                        <v-btn :disabled="btn[4].isActive" v-if="modeStatus === 'changeMode'" color="green darken-4" text @click="removeOverlay = !removeOverlay">管理ユーザーを削除する</v-btn>
                        <v-btn :disabled="btn[3].isActive" v-if="modeStatus === 'changeMode'" color="green darken-4" text @click="validateCheck">管理ユーザーを変更する</v-btn>
                    </v-card-actions>
                    <v-overlay :value="removeOverlay">
                        <v-card light width="500px">
                            <v-card-title v-if="result === ''">管理ユーザー削除の最終確認</v-card-title>
                            <v-card-title v-if="result !== ''">管理ユーザー削除</v-card-title>
                            <v-card-text v-if="result === ''">{{ full_name }}さんの管理ユーザーを削除します。<br>削除後、情報の復元はできません。</v-card-text>
                            <v-card-text v-if="result !== ''">{{ resultText }}</v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn v-if="result === ''" color="primary" text @click="removeOverlay = !removeOverlay">キャンセル</v-btn>
                                <v-btn v-if="result === ''" color="primary" text @click="removeAdminMember">削除する</v-btn>
                                <v-btn v-if="result !== ''" color="primary" text @click="CloseModal">閉じる</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-overlay>
                    <v-overlay :value="changeOverlay">
                        <v-card light width="500px">
                            <v-card-title v-if="result === ''">管理ユーザー変更の最終確認</v-card-title>
                            <v-card-title v-if="result !== ''">管理ユーザー変更</v-card-title>
                            <v-card-text v-if="result === ''">{{ full_name }}さんの管理ユーザーを変更します。</v-card-text>
                            <v-card-text v-if="result !== ''">{{ resultText }}</v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn v-if="result === ''" color="primary" text @click="changeOverlay = !changeOverlay">キャンセル</v-btn>
                                <v-btn v-if="result === ''" color="primary" text @click="changeAdminMember">変更する</v-btn>
                                <v-btn v-if="result !== ''" color="primary" text @click="CloseModal">閉じる</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-overlay>
                    <v-overlay :value="addOverlay">
                        <v-card light width="500px">
                            <v-card-title v-if="result === ''">管理ユーザー追加の最終確認</v-card-title>
                            <v-card-title v-if="result !== ''">管理ユーザー追加</v-card-title>
                            <v-card-text v-if="result === ''">管理ユーザーを追加します。</v-card-text>
                            <v-card-text v-if="result !== ''">{{ resultText }}</v-card-text>
                            <v-divider></v-divider>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn v-if="result === ''" color="primary" text @click="addOverlay = !addOverlay">キャンセル</v-btn>
                                <v-btn v-if="result === ''" color="primary" text @click="addAdminMember">追加する</v-btn>
                                <v-btn v-if="result !== ''" color="primary" text @click="CloseModal">閉じる</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-overlay>
                </v-card>
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '../../components/module/CardTitle';
import validater from '../../lib/validater';
import {
    REGISTER_ADMIN,
    GET_ADMIN,
    UPDATE_ADMIN,
    DELETE_ADMIN } from '../../constants/admin';
// import { GET_GOLFCOURSE } from '../../constants/member_point_history';
import {
    GET_FLAG_FROM_CODE_MASTER,
    GET_GOLFCOURSE_FOR_SYSTEM_ADMIN
} from '../../constants/master';

export default {
    components: {
        CardTitle
    },
    props: [
        'btn'
    ],
    data () {
        return {
            // 追加確認用ポップアップ表示に関する制御値
            addOverlay: false,
            // 変更確認用ポップアップ表示に関する制御値
            changeOverlay: false,
            // 削除確認用ポップアップ表示に関する制御値
            removeOverlay: false,
            // 処理結果
            result: '',
            // 処理結果メッセージ
            resultText: '',
            // モーダルタイトル コンポーネントに渡す値：モーダルタイトル
            page_title: '',
            // 画面のモード指定
            // [値：checkData = 管理ユーザー参照],[値：addMember = 会員追加],[値：changeData = 情報変更]
            modeStatus: '',
            // 必須項目に関するチェック値
            valid: true,
            // 入力項目の活性・非活性制御値 [true=入力不可][false=入力可]
            inputDisable: false,
            // パスワード項目の活性・非活性制御値 [true=入力不可][false=入力可]
            inputPasswordDisable: false,
            // モーダル画面表示制御値
            dialog: false,
            // バリデーションチェック値
            lazy: false,
            // 情報変更を行う際の制御値
            data_change_flag: false,
            // 入力値管理用
            from_set_data: {
                // 苗字
                family_name: '',
                // 名前
                given_name: '',
                // ゴルフ場
                golf_code: '',
                // 管理者権限
                user_div: '',
                // 管理ユーザーのログインID
                user_name: '',
                // 管理ユーザーの変更前のユーザーネーム
                save_user_name: '',
                // パスワード
                password: '',
                // 表示用パスワード
                display_password: '',
                // メールアドレス
                email: ''
            },
            // getAdminで取得したuser_id
            user_id: '',
            // process.env.VUE_APP_GRUOP_CODEの値
            golf_groups_val: '',
            // 所属ゴルフグループから取得したゴルフ場
            golf_courses: [],
            // ゴルフ場セレクトボックスの値
            golf_courses_val: '',
            // 権限セレクトボックスの値
            user_divs: [],
            // パスワード項目の可視化：非表示
            show_password: false,
            rules: {
                // 氏名（姓）バリデーション
                required_family_name: value => !!value || this.$t('error.validation.required.familyName'),
                max_length_family_name: value => value.length <= 50 || this.$t('error.validation.length.familyName'),
                // 氏名（名）バリデーション
                required_given_name: value => !!value || this.$t('error.validation.required.givenName'),
                max_length_given_name: value => value.length <= 50 || this.$t('error.validation.length.givenName'),
                // user_id バリデーション
                required_user_id: value => !!value || this.$t('error.validation.required.userId'),
                // パスワードバリデーション
                required_password: value => !!value || this.$t('error.validation.required.password'),
                format_password: value => validater.checkStringType(value) || this.$t('error.validation.stringtype'),
                format_password_complexity: value => validater.checkComplexity(value) || this.$t('error.validation.complexity'),
                max_length_password: value => value.length <= 128 || this.$t('error.validation.length.passwordMax'),
                min_length_password: value => value.length >= 10 || this.$t('error.validation.length.adminPasswordMin'),
                // メールアドレスバリデーション
                required_email: value => !!value || this.$t('error.validation.required.email'),
                format_email: value => !!validater.checkMail(value) || this.$t('error.validation.mailFormat'),
                max_length_email: value => value.length <= 256 || this.$t('error.validation.length.mail')
            }
        };
    },
    computed: {
        full_name: function () {
            return this.from_set_data.family_name + ' ' + this.from_set_data.given_name;
        }
    },
    watch: {
        modeStatus: function () {
            if (this.modeStatus === 'checkMode') {
                this.page_title = '管理ユーザー参照';
                this.inputDisable = true;
            } else if (this.modeStatus === 'addMode') {
                this.page_title = '管理ユーザー登録';
                this.inputDisable = false;
            } else if (this.modeStatus === 'changeMode') {
                this.page_title = '管理ユーザー変更';
                this.inputDisable = false;
            }
        },
        'from_set_data.user_div' () {
            if (this.from_set_data.user_div === '1') {
                this.golf_courses_val = process.env.VUE_APP_ADMIN_GOLF_CODE;
            }
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期化処理
         * ---------------------------------------------- */
        Initialize () {
            this.modeStatus = '';
            this.from_set_data = {
                // 苗字
                family_name: '',
                // 名前
                given_name: '',
                // ゴルフ場
                golf_code: '',
                // 管理者権限
                user_div: '',
                // 管理ユーザーのユーザーネーム
                user_name: '',
                // 管理ユーザーの変更前のユーザーネーム
                save_user_name: '',
                // パスワード
                password: '',
                // メールアドレス
                email: ''
            };
            this.inputDisable = true;
            this.addOverlay = false;
            this.changeOverlay = false;
            this.removeOverlay = false;
            this.golf_courses_val = false;
            this.result = '';
            this.resultText = '';
            this.golf_groups_val = process.env.VUE_APP_GROUP_CODE;
            // コードマスタより管理者区分のリストを取得
            this.$apollo.query({
                query: GET_FLAG_FROM_CODE_MASTER,
                variables: {
                    code_key: 'authority',
                    default_display: 0
                }
            }).then(res => {
                this.user_divs = res.data.GetCodeList.CodeList;
            });
        },
        /** ----------------------------------------------
         * 管理ユーザーを取得
         * ---------------------------------------------- */
        getAdmin () {
            this.$apollo.mutate({
                fetchPolicy: 'no-cache',
                mutation: GET_ADMIN,
                variables: { user_id: this.user_id }
            }).then(res => {
                this.from_set_data = res.data.GetAdmin;
                this.from_set_data.family_name = res.data.GetAdmin.family_name;
                this.from_set_data.given_name = res.data.GetAdmin.given_name;
                this.from_set_data.golf_code = res.data.GetAdmin.golf_code;
                this.from_set_data.user_div = res.data.GetAdmin.user_div;
                this.from_set_data.user_name = res.data.GetAdmin.user_name;
                this.from_set_data.save_user_name = res.data.GetAdmin.user_name;
                this.golf_courses_val = res.data.GetAdmin.golf_code;
                this.from_set_data.password = res.data.GetAdmin.display_password;
                this.from_set_data.email = res.data.GetAdmin.email;
            }).catch(error => {
                this.result = 0;
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * ゴルフ場を取得
         * ---------------------------------------------- */
        getGolfCourse () {
            this.$apollo
                .query({
                    fetchPolicy: 'no-cache',
                    query: GET_GOLFCOURSE_FOR_SYSTEM_ADMIN,
                    variables: { golf_group_code: this.golf_groups_val }
                })
                .then(res => {
                    this.data = res.data.getGolfCourseForSystemAdmin;
                    this.data.forEach(data => {
                        this.golf_courses.push(data);
                    });
                })
                .catch(error => {
                    this.result = 0;
                    this.error = error;
                });
        },
        /** ----------------------------------------------
         * 管理者情報追加
         * ---------------------------------------------- */
        addAdminMember () {
            let insertGolfCode = this.golf_courses_val;
            // システム管理者の場合
            if (this.from_set_data.user_div === '1') {
                insertGolfCode = process.env.VUE_APP_ADMIN_GOLF_CODE;
            }
            this.$apollo.mutate({
                mutation: REGISTER_ADMIN,
                variables: {
                    user_name: this.from_set_data.user_name,
                    family_name: this.from_set_data.family_name,
                    given_name: this.from_set_data.given_name,
                    password: this.from_set_data.password,
                    golf_group_code: this.golf_groups_val,
                    golf_code: insertGolfCode,
                    user_div: this.from_set_data.user_div,
                    email: this.from_set_data.email
                }
            }).then(res => {
                this.result = res.data.RegisterAdmin.result;
                // 結果、正常であれば所属ゴルフグループ情報に登録
                if (this.result === 1) {
                    this.resultText = this.$t('result.success.add');
                } else if (this.result === 2) {
                    this.resultText = this.$t('result.error.duplication');
                } else {
                    this.resultText = this.$t('result.error.add');
                }
            }).catch(error => {
                this.result = 0;
                this.resultText = this.$t('result.error.add');
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * 管理ユーザー変更
         * ---------------------------------------------- */
        changeAdminMember () {
            let insertGolfCode = this.golf_courses_val;
            // システム管理者の場合
            if (this.from_set_data.user_div === '1') {
                insertGolfCode = process.env.VUE_APP_ADMIN_GOLF_CODE;
            }
            this.$apollo.mutate({
                mutation: UPDATE_ADMIN,
                variables: {
                    user_id: this.user_id,
                    user_name: this.from_set_data.user_name,
                    save_user_name: this.from_set_data.save_user_name,
                    family_name: this.from_set_data.family_name,
                    given_name: this.from_set_data.given_name,
                    password: this.from_set_data.password,
                    golf_group_code: this.golf_groups_val,
                    golf_code: insertGolfCode,
                    user_div: this.from_set_data.user_div,
                    email: this.from_set_data.email
                }
            }).then(res => {
                this.result = res.data.UpdateAdmin.result;
                if (this.result === 1) {
                    this.resultText = this.$t('result.success.change');
                } else if (this.result === 2) {
                    this.resultText = this.$t('result.error.duplication');
                } else {
                    this.resultText = this.$t('result.error.change');
                }
            }).catch(error => {
                this.result = 0;
                this.resultText = this.$t('result.error.change');
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * 管理ユーザー削除
         * ---------------------------------------------- */
        removeAdminMember () {
            this.$apollo.mutate({
                mutation: DELETE_ADMIN,
                variables: { user_id: this.user_id }
            }).then(res => {
                this.result = res.data.DeleteAdmin.result;
                if (this.result === 1) {
                    this.resultText = this.$t('result.success.remove');
                } else {
                    this.resultText = this.$t('result.error.remove');
                }
            }).catch(error => {
                this.result = 0;
                this.resultText = this.$t('result.error.remove');
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * チェック処理
         * ---------------------------------------------- */
        validateCheck () {
            if (this.$refs.member_form.validate()) {
                if (this.modeStatus === 'addMode') {
                    this.addOverlay = true;
                } else if (this.modeStatus === 'changeMode') {
                    this.changeOverlay = true;
                }
            }
        },
        /** ----------------------------------------------
         * 親画面にて「追加」ボタン押下時の処理
         * @param val モーダル画面の表示用制御値
         * @param mode 画面のモード指定''
         * ---------------------------------------------- */
        ModalControl: function (val, mode) {
            this.Initialize();
            this.modeStatus = mode;
            this.getGolfCourse();
            // 初期表示で「ゴルフ場担当者」を選択
            this.from_set_data.user_div = '10';
            this.golf_courses_val = process.env.VUE_APP_ADMIN_GOLF_CODE;
            this.dialog = val;
            this.data_change_flag = true;
        },
        /** ----------------------------------------------
         * 親画面にて「詳細表示」ボタン押下時の処理
         * 親画面から渡ってきたデータを各項目に渡す
         * @param val モーダル画面の表示用制御値
         * @param el 押下したボタンに紐づく行内の各データ
         * @param mode 画面のモード指定
         * ---------------------------------------------- */
        async InfoAdminModal (val, el, mode) {
            await this.Initialize();
            this.modeStatus = mode;
            this.user_id = el.user_id;
            await this.getGolfCourse();
            await this.getAdmin();
            this.dialog = val;
        },
        /** ----------------------------------------------
         * 詳細表示画面表示に情報変更ボタンを押下した際の処理
         * ---------------------------------------------- */
        InfoChangeData () {
            this.modeStatus = 'changeMode';
            this.data_change_flag = true;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.$refs.member_form.resetValidation();
            this.dialog = false;
            this.$emit('refresh-event');
            this.Initialize();
        }
    }
};
</script>
